import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Snackbar } from '@mui/material';
import FileCopy from '@mui/icons-material/FileCopy';

import { AUTOCLOSE_ALERT_DELAY } from '../../shared/constants/snackbar.constants';

import './styles.scss';

const CopyToClipboard = ({ value }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async () => {
    await window.navigator.clipboard.writeText(value);
    setIsCopied(true);
  };

  const handleClose = () => {
    setIsCopied(false);
  };

  return (
    <>
      <span className="clipboard-wrapper">
        <span className="text" title={value}>
          {value}
        </span>
        <FileCopy className="icon" onClick={copyToClipboard} />
      </span>
      <Snackbar
        open={isCopied}
        autoHideDuration={AUTOCLOSE_ALERT_DELAY}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success">
          Successfully copied to the clipboard!
        </Alert>
      </Snackbar>
    </>
  );
};

CopyToClipboard.propTypes = {
  value: PropTypes.string
};

CopyToClipboard.defaultTypes = {
  value: ''
};

export default CopyToClipboard;
